export const formatPhone = (telefone: string | undefined): string => {
  if (!telefone) return '';

  if (telefone.length === 10) {
    return telefone.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
  }

  if (telefone.length === 11) {
    return telefone.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
  }

  return telefone;
}

export const removeNonNumeric = (input: string | undefined): string => {
  if (!input) return ''
  
  const response = input.replace(/\D/g, '')
  console.log(response)
  return response
}
